module.exports = __webpack_public_path__ + "img/play-store-icon.30beae41.svg";